"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const utils_1 = require("utils");
const PrintReceiptOnlyBtn = ({ transactionId, getSalesReceipt, }) => {
    // State
    const [loading, setLoading] = (0, react_1.useState)(false);
    // Print Normal
    const handlePrint = (transactionId) => {
        setLoading(true);
        getSalesReceipt(transactionId)
            .then((pdfWindowURL) => {
            (0, utils_1.windowOpenAndPrint)(pdfWindowURL); // Print
        })
            .catch(() => {
            (0, utils_1.toastError)('PDF download and print failed');
        })
            .finally(() => setLoading(false));
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-primary button-warn print-receipt-button", invalid: loading, submitting: loading, onClick: () => {
                handlePrint(transactionId);
            }, children: "PRINT RECEIPT" }) }));
};
function mapStateToProps() {
    return {};
}
const mapApiAuthToProps = {
    getSalesReceipt: apiActions.getSalesReceipt,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(PrintReceiptOnlyBtn);
